module.exports = __webpack_public_path__ + "img/02.367ca444.png";